// ─── Laying out a month ──────────────────────────────────────────────────────
//
// Monday-first, always a whole number of weeks, with the leading and trailing
// days of the adjacent months included so the grid never has holes in it.
//
// Pure date arithmetic, no library. It is the kind of code that looks trivial
// and is where off-by-one errors live, so it is separated out and tested
// directly rather than being tangled into a component.

export type MonthGridDay = { date: Date; inMonth: boolean };

/** 0 = Monday. JavaScript's getDay() is Sunday-first, which is not the
 *  documented default for this product. */
export function mondayFirstWeekday(date: Date): number {
  return (date.getDay() + 6) % 7;
}

export function buildMonthGrid(year: number, monthIndex: number): MonthGridDay[] {
  const first = new Date(year, monthIndex, 1);
  const start = new Date(first);
  start.setDate(first.getDate() - mondayFirstWeekday(first));

  const days: MonthGridDay[] = [];
  const cursor = new Date(start);
  // Six weeks covers every possible month layout; trailing whole weeks that
  // belong entirely to the next month are dropped, so a short month does not
  // render an empty final row.
  for (let i = 0; i < 42; i++) {
    days.push({ date: new Date(cursor), inMonth: cursor.getMonth() === monthIndex });
    cursor.setDate(cursor.getDate() + 1);
  }
  while (days.length > 28 && days.slice(-7).every(d => !d.inMonth)) days.length -= 7;
  return days;
}
